export function normalizeId(value: any): string {
  return String(value ?? '')
}

export function ensureSelectedId(items: any[], selectedId: string, getId = (item: { id: any }) => item?.id) {
  const rows = Array.isArray(items) ? items : []
  if (!rows.length) return ''
  const wanted = normalizeId(selectedId)
  const found = rows.find((item) => normalizeId(getId(item)) === wanted)
  return normalizeId(found ? getId(found) : getId(rows[0]))
}

export function navigateSelectedId(items: any[], selectedId: string, direction: string, getId = (item: { id: any }) => item?.id) {
  const rows = Array.isArray(items) ? items : []
  if (!rows.length) return ''
  const current = normalizeId(selectedId)
  const index = Math.max(0, rows.findIndex((item) => normalizeId(getId(item)) === current))
  if (direction === 'first') return normalizeId(getId(rows[0]))
  if (direction === 'last') return normalizeId(getId(rows[rows.length - 1]))
  if (direction === 'prev') return normalizeId(getId(rows[Math.max(0, index - 1)]))
  return normalizeId(getId(rows[Math.min(rows.length - 1, index + 1)]))
}

export function formatDateTimeShort(value: string | number | Date): string {
  if (!value) return ''
  try {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return date.toLocaleString([], {
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return ''
  }
}

export function formatDateTimeLong(value: string | number | Date): string {
  if (!value) return ''
  try {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return date.toLocaleString([], {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return ''
  }
}

export function formatDateOnly(value: string | number | Date): string {
  if (!value) return ''
  try {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return date.toLocaleDateString([], {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    })
  } catch {
    return ''
  }
}
